import {
  styled
} from 'styled-components'
import { GridBase } from '../../base/GridBase'

export const GridWrapper = styled(GridBase)`
    /* Parent
    ------------------------------- */
    /* Childrens
    ------------------------------- */
    /* Modifiers
    ------------------------------- */
    .grid-column-base {
      &.is-flex-column {
        display: flex;
        flex-direction: column;
      }
    }

    /* Media queries
    ------------------------------- */
`
